import React, { useEffect, useState } from 'react'
import styles from './toggle-switch.module.scss'

interface IProps {
  label?: any,
  onChange?: any
  readonly?: boolean
  textSize?: 'large'
  checked?: boolean
}

let id = 0

const ToggleSwitch = React.memo(function (props: IProps) {
  id++
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    setChecked(props.checked)
  }, [props.checked])

  const handleChange = (e: any) => {
    e.stopPropagation()
    if (!props.readonly) {
      props.onChange(e.target.checked)
      setChecked(e.target.checked)
    }
  }

  return (
    <div className={styles.toggleSwitch}>
      <input readOnly={props.readonly} type="checkbox" id={id.toString()} name={props.label} className={styles.input} onChange={(e) => handleChange(e)} checked={checked} />
      <label htmlFor={id.toString()} className={`${styles.label} ${styles[props.textSize]} ${!props.readonly ? 'cursor-pointer' : ''} ${props.label ? styles.withLabel : ''}`} dangerouslySetInnerHTML={{ __html: props.label }} />
    </div>
  )
})

export default ToggleSwitch
